var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "total-wrapper" }, [
    _c("span", { staticClass: "total-title" }, [_vm._v("Total")]),
    _vm._v(" "),
    _c("span", { staticClass: "total-price" }, [
      _vm._v(_vm._s(_vm._f("toCurrency")(this.total))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }